/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_register_error_complete_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to complete registration`)
};

const zh_hans1_register_error_complete_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法完成注册`)
};

const zh_hant1_register_error_complete_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法完成註冊`)
};

const fr_register_error_complete_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de terminer l’inscription`)
};

const de_register_error_complete_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrierung konnte nicht abgeschlossen werden`)
};

const ja_register_error_complete_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録を完了できませんでした`)
};

const ko_register_error_complete_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등록을 완료하지 못했습니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register_error_complete_failed = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register_error_complete_failed(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register_error_complete_failed", locale)
	if (locale === "en") return en_register_error_complete_failed(inputs)
	if (locale === "zh-Hans") return zh_hans1_register_error_complete_failed(inputs)
	if (locale === "zh-Hant") return zh_hant1_register_error_complete_failed(inputs)
	if (locale === "fr") return fr_register_error_complete_failed(inputs)
	if (locale === "de") return de_register_error_complete_failed(inputs)
	if (locale === "ja") return ja_register_error_complete_failed(inputs)
	return ko_register_error_complete_failed(inputs)
};